import {
  LOAD_NOTIFICATION,
  NOTIFICATION_IS_READ,
  RECEIVE_NOTIFICATION,
  REMOVE_NOTIFICATION,
  REQUEST_NOTIFICATION,
} from "redux/constants/Notifications";

const initState = [
  // { id: 1, text: "Test Notification1" },
  // { id: 2, text: "Test Notification2" },
];

const notification = (state = initState, action) => {
  switch (action.type) {
    case REQUEST_NOTIFICATION:
      return [...state];

    case LOAD_NOTIFICATION:
      return [...state, ...action.data];

    case RECEIVE_NOTIFICATION: {
      var notificationObj =
        typeof action.notification === "object" && action.notification !== null
          ? action.notification
          : {
              id: Math.floor(Math.random() * (100000 - 1 + 1)) + 1,
              message: action.notification,
              isRead: false,
            };
      return [...[notificationObj], ...state];
    }
    case NOTIFICATION_IS_READ:
      return state.map((obj) => {
        if (obj.id === action.notificationId) return { ...obj, isRead: true };
        return obj;
      });
    case REMOVE_NOTIFICATION:
      return state.filter((obj) => obj.id !== action.notificationId);
    default:
      return state;
  }
};

export default notification;
